export const unitsEnumArray = [
  'kg',
  'km',
  'l',
  'lfm',
  'm',
  'm2',
  'm3',
  'min',
  'pkg',
  'flat_rate',
  'std',
  'stk',
  't',
  'day',
  'qmw',
] as const
export type Unit = (typeof unitsEnumArray)[number]

export const unitsEnumArrayEnabledByDefault = unitsEnumArray.filter(
  (unit) => unit !== 'qmw',
) as Unit[]

// The UNITS_DE/UNITS_EN/UNITS_DE_REVERSE re-exports that lived here were dead
// (every consumer imports the label maps from @w/fe-inv-i18n directly) and
// value-imported the i18n barrel - dragging i18next/react into drizzle-kit's
// schema loading. This file stays a dependency-free leaf on purpose (VA-223).

// The following mapping is based on the UNTDID 20 code list:
// https://unece.org/sites/default/files/2023-10/rec20_rev3_Annex2e.pdf
// https://www.xrepository.de/details/urn:xoev-de:kosit:codeliste:rec20_3#version
export const UNITS_TO_CODES: Record<Unit, string> = {
  kg: 'KGM',
  km: 'KMT',
  l: 'LTR',
  lfm: 'LM',
  m: 'MTR',
  m2: 'MTK',
  m3: 'MTQ',
  min: 'MIN',
  pkg: 'AB',
  flat_rate: 'A9',
  std: 'HUR',
  stk: 'H87',
  t: 'TNE',
  day: 'DAY',
  qmw: 'C62',
}
